import {
  callApiImportData,
  callApiDownloadTemplate,
  callApiExportData
} from "@/api/import-service";

const importData = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiImportData(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};
const downloadTemplate = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDownloadTemplate(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

const exportData = (context, payload) => {
  if (payload.type === "CapDonVi") {
    payload.endPoint = "/Import/export-cap-don-vi";
  } else if (payload.type === "NhomChucVu") {
    payload.endPoint = "/Import/export-nhom-chuc-vu";
  } else if (payload.type === "ChucVu") {
    payload.endPoint = "/Import/export-chuc-vu";
  } else if (payload.type === "CanBo") {
    payload.endPoint = "/Import/export-can-bo";
  } else if (payload.type === "DonVi") {
    payload.endPoint = "/Import/export-don-vi";
  } else if (payload.type === "NguoiDung") {
    payload.endPoint = "/Import/export-user";
  } else if (payload.type === "InThe") {
    payload.endPoint = "/Export/export-can-bo-in-the";
  }
  return new Promise((resolve, reject) => {
    callApiExportData(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export default {
  importData,
  exportData,
  downloadTemplate
};
